angular.module('lingoda.animation', [])
.directive('lingShowWrapper', ['$timeout', function($timeout) {
    return {
        restrict: 'C',
        link: function(scope, iElement) {

            var timeoutID,
                getHeight = function() {
                    var height = 0;
                    angular.forEach(iElement.children(), function(child) {
                        height += child.offsetHeight;
                    });
                    height += parseInt(iElement.css('border-bottom-width'), 10);
                    height += parseInt(iElement.css('border-top-width'), 10);
                    height += parseInt(iElement.css('padding-top'), 10);
                    height += parseInt(iElement.css('padding-bottom'), 10);
                    return height;
                },
                show = function() {
                    if(iElement[0].style.height !== 'auto' && iElement[0].style.height !== '') {
                        iElement.css({
                            transition: '0.5s all'
                        });
                    }
                    $timeout(function() {
                        iElement.css({
                            height: getHeight()
                        });
                    });
                };

            scope.$on('ling:animation:show', function(e) {
                e.preventDefault();
                e.stopPropagation();

                show();

                //Animation inheritance behavior
                $timeout.cancel(timeoutID);
                timeoutID = $timeout(function() {
                    iElement.css({
                        transition: 'none'
                    });

                    $timeout(function() {
                        iElement.css({
                            height: 'auto'
                        });
                    });
                }, 800);
            });
        }
    }
}])
.directive('lingShow', ['$timeout', function($timeout) {
    return {
        restrict: 'A',
        scope: true,
        link: function(scope, iElement, iAttrs) {
            var initialized = false,
                timeoutID,
                counter = 0,
                config = $.extend({
                    effectIn: 'fadeIn',
                    effectOut: 'fadeOut'
                }, iAttrs);

            iElement.addClass('rendering animated').css('animation-duration', '0.5s');
            scope.$watch(iAttrs.lingShow, function(v) {
                $timeout.cancel(timeoutID);
                if(v) {
                    scope.beforeHide = false;
                    scope.beforeShow = true;
                    if(initialized) {
                        timeoutID = $timeout(function() {
                            scope.show = true;
                            $timeout(function() {
                                scope.$emit('ling:animation:show');
                            }, 1);
                        }, 600);
                    } else {
                        scope.show = true;
                        initialized = true;
                    }
                } else {
                    scope.beforeShow = false;
                    scope.beforeHide = true;
                    if(initialized) {
                        scope.$emit('ling:animation:show');
                        timeoutID = $timeout(function() {
                            scope.show = false;
                        }, 600);
                    } else {
                        scope.show = false;
                        initialized = true;
                    }
                }
                if(counter > 0) {
                    iElement.removeClass('rendering');
                } else {
                    counter++;
                }
            });
            scope.$watch('show', function(v) {
                if(v) {
                    iElement.removeClass('ng-cloak').addClass(config.effectIn);
                } else {
                    iElement.addClass('ng-cloak').removeClass(config.effectIn);
                }
            });
            scope.$watch('beforeHide', function(v) {
                if(v) {
                    iElement.addClass(config.effectOut);
                } else {
                    iElement.removeClass(config.effectOut);
                }
            });
        }
    }
}])
.directive('lingAnimShow', ['$timeout', '$parse', function($timeout, $parse) {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            var helper = $('<div class="anim-show-helper"></div>'),
                timeoutID = null,
                rendered = false,
                toggle = function(v) {
                    if(!rendered) {
                        if(v) {
                            attrs.$removeClass('ng-cloak');
                            attrs.$addClass('anim-show-visible');
                            rendered = true;
                        } else if(v === false) {
                            attrs.$addClass('ng-cloak');
                            attrs.$removeClass('anim-show-visible');
                            rendered = true;
                        } else {
                            attrs.$addClass('ng-cloak');
                            attrs.$removeClass('anim-show-visible');
                        }
                        return;
                    }
                    if(!element.hasClass('anim-show-loading')) {
                        if(v) {
                            $timeout.cancel(timeoutID);
                            element.css({
                                height: 0
                            });
                            attrs.$addClass('anim-show-showing');
                            attrs.$addClass('anim-show-loading');
                            attrs.$addClass('anim-show-visible');
                            helper.css('marginTop', 0);
                            attrs.$addClass('anim-show-prepare');
                            attrs.$removeClass('ng-cloak');
                            var diff = element[0].scrollHeight;
                            helper.css('marginTop', -1 * diff);
                            $timeout(function() {
                                scope.$emit('ling:anim:show:before', v, attrs.lingAnimShow, diff);
                                element.css('height', 'auto');
                                attrs.$removeClass('anim-show-showing');
                                helper.css('marginTop', 0);

                                timeoutID = $timeout(function() {
                                    attrs.$removeClass('anim-show-loading');
                                    attrs.$removeClass('anim-show-prepare');
                                    var currentValue = $parse(attrs.lingAnimShow)(scope);
                                    if(v !== currentValue) {
                                        toggle(currentValue);
                                    }
                                    $timeout(function() {
                                        scope.$emit('ling:anim:show:after', v, attrs.lingAnimShow);
                                    }, 100);
                                }, 300);
                            });
                        } else if(v === false) {
                            $timeout.cancel(timeoutID);
                            attrs.$removeClass('anim-show-showing');
                            attrs.$removeClass('anim-show-visible');
                            attrs.$addClass('anim-show-loading');
                            attrs.$addClass('anim-show-prepare');
                            $timeout(function() {
                                scope.$emit('ling:anim:show:before', v, attrs.lingAnimShow, -1 * element.outerHeight());
                                helper.css('marginTop', -1 * element.outerHeight());

                                timeoutID = $timeout(function() {
                                    attrs.$addClass('ng-cloak');
                                    attrs.$removeClass('anim-show-loading');
                                    attrs.$removeClass('anim-show-prepare');
                                    var currentValue = $parse(attrs.lingAnimShow)(scope);
                                    if(v !== currentValue) {
                                        toggle(currentValue);
                                    }
                                    $timeout(function() {
                                        scope.$emit('ling:anim:show:after', v, attrs.lingAnimShow);
                                    }, 100);
                                }, 300);
                            });
                        } else {
                            attrs.$addClass('ng-cloak');
                        }
                    }

                };
            element.prepend(helper);
            scope.$watch(attrs.lingAnimShow, toggle);
        }
    }
}])
;
